import { render } from "./CollapseMenu.vue?vue&type=template&id=0abbec7a&scoped=true&ts=true"
import script from "./CollapseMenu.vue?vue&type=script&lang=ts"
export * from "./CollapseMenu.vue?vue&type=script&lang=ts"

import "./CollapseMenu.vue?vue&type=style&index=0&id=0abbec7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abbec7a"]])

export default __exports__